<!-- "Make Sense of Your Results" static-prompt popover body (static-prompts
     MVP). Rendered by the Orbi entry bar as a floating popover anchored to the
     "Ask a Question" bar; the host controls mount/show. The caret points at the
     bar — UP (popover below the bar, web/top-right) or DOWN (popover above the
     bar, mobile/docked) — set by `caretDirection`. -->
<section
  class="static-prompt-card"
  [class.static-prompt-card--caret-up]="caretDirection === 'up'"
  [class.static-prompt-card--caret-down]="caretDirection === 'down'"
  role="dialog"
  aria-labelledby="static-prompt-card-heading"
>
  <span class="static-prompt-card__caret" aria-hidden="true"></span>

  <div class="static-prompt-card__header">
    <h2 id="static-prompt-card-heading" class="static-prompt-card__heading">
      {{ heading }}
      <span class="material-icons-round static-prompt-card__sparkle" aria-hidden="true">auto_awesome</span>
    </h2>
    <button type="button" class="static-prompt-card__dismiss" aria-label="Dismiss" (click)="onDismiss()">
      <span class="material-icons-round" aria-hidden="true">close</span>
    </button>
  </div>

  <p class="static-prompt-card__subtext">{{ subtext }}</p>

  <ul class="static-prompt-card__prompts">
    <li *ngFor="let prompt of prompts; trackBy: trackByPrompt">
      <button type="button" class="static-prompt-card__prompt" (click)="onPromptClick(prompt)">
        <span class="static-prompt-card__prompt-label">{{ prompt.shortPrompt }}</span>
        <span class="material-icons-round static-prompt-card__prompt-submit" aria-hidden="true">arrow_upward</span>
      </button>
    </li>
  </ul>
</section>
